<template>
  <Tabs>
    <Tab name="Sign Up">
      <h2 class="heading">{{ bonus }} Credit Towards Order</h2>

      <p class="text">
        Sign up and create a Members Only account to receive
        {{ bonus }} credit* towards your first order, enjoy rewards and
        benefits, and be the first to know about all things Rat & Boa. Credit
        cannot be used on sale items.
      </p>

      <BenefitIcons
        :items="{
          star: 'Exclusive rewards',
          'sell-tag': 'Priority sale access',
          'add-task': 'Vote on styles',
        }"
      />

      <SingleSignOn />

      <div class="divider">or</div>

      <RegisterForm @success="handleFormSuccess" />
    </Tab>
    <Tab name="Login">
      <LoginForm @success="handleFormSuccess" />
    </Tab>
  </Tabs>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import LoginForm from "@/components/account/LoginForm.vue";
import RegisterForm from "@/components/account/RegisterForm.vue";
import SingleSignOn from "@/components/SingleSignOn.vue";
import BenefitIcons from "@/components/BenefitIcons.vue";
import { signUpBonus } from "@/config.js";

export default {
  name: "RegisterAndLoginPanel",
  components: {
    Tabs,
    Tab,
    LoginForm,
    RegisterForm,
    SingleSignOn,
    BenefitIcons,
  },
  emits: ["success"],
  data() {
    return {
      open: false,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    ...mapState("auth", ["multipassAccount"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }

      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
  methods: {
    handleFormSuccess() {
      this.$emit("success", this.redirect);
    },
    redirect() {
      window.location.href = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.tabs-component-tabs) {
  text-align: center;
}
.divider {
  position: relative;
  text-align: center;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 600;
  margin-bottom: 20px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border-bottom: solid 1px #d4d4d4;
    width: 40%;
    left: 0;
  }

  &::after {
    left: auto;
    right: 0;
  }
}

.sso-buttons {
  border-bottom: none;
  margin: 0 -20px 40px;
  padding: 0 20px;

  ::v-deep(.button) {
    &:first-child {
      margin: 0 0 10px 0;
    }
  }
}

.heading {
  margin-top: 20px;
  text-align: center;
  font-size: 28px;
  font-weight: 400;
  text-transform: uppercase;
}

.text {
  font-size: 13px;
  margin: 10px 0 50px 0;
  text-align: center;
  font-weight: 400;
  font-family: $body-font-family;
}

::v-deep(.loyalty-benefits-icons) {
  margin: 30px auto;

  @include respond-above(md) {
    margin: 30px auto;
  }

  p {
    font-size: 13px;
  }
}
</style>
